import { TrendingUp, TrendingDown } from 'lucide-react'

/**
 * @param {object}  props
 * @param {string}  props.title
 * @param {string}  props.value
 * @param {string}  [props.subtitle]
 * @param {number}  [props.trend]        — positive = up, negative = down, 0/undefined = neutral
 * @param {'green'|'red'|'blue'|'amber'|'default'} [props.color]
 * @param {React.ReactNode} [props.icon]
 * @param {boolean} [props.loading]
 */
export default function StatsCard({
  title,
  value,
  subtitle,
  trend,
  color = 'default',
  icon,
  loading = false,
}) {
  const colorMap = {
    green:   { card: 'border-green-200',  val: 'text-green-700',  sub: 'text-green-500',  badge: 'bg-green-50'  },
    red:     { card: 'border-red-200',    val: 'text-red-700',    sub: 'text-red-500',    badge: 'bg-red-50'    },
    blue:    { card: 'border-blue-200',   val: 'text-blue-700',   sub: 'text-blue-500',   badge: 'bg-blue-50'   },
    amber:   { card: 'border-amber-200',  val: 'text-amber-700',  sub: 'text-amber-500',  badge: 'bg-amber-50'  },
    default: { card: 'border-slate-200',  val: 'text-slate-800',  sub: 'text-slate-500',  badge: 'bg-slate-50'  },
  }

  const c = colorMap[color] ?? colorMap.default

  if (loading) {
    return (
      <div className={`card p-5 ${c.card}`}>
        <div className="skeleton h-4 w-28 rounded mb-3" />
        <div className="skeleton h-8 w-36 rounded mb-2" />
        <div className="skeleton h-3 w-24 rounded" />
      </div>
    )
  }

  return (
    <div className={`card p-5 ${c.card} hover:shadow-md transition-shadow`}>
      <div className="flex items-start justify-between mb-1">
        <p className="text-sm font-medium text-slate-500">{title}</p>
        {icon && (
          <div className={`p-2 rounded-lg ${c.badge}`}>
            {icon}
          </div>
        )}
      </div>

      <p className={`text-2xl font-bold ${c.val} mt-1 mb-1`}>{value}</p>

      <div className="flex items-center gap-2">
        {subtitle && (
          <div className={`text-xs ${c.sub} w-full`}>{subtitle}</div>
        )}
        {trend !== undefined && trend !== null && (
          <span className={[
            'flex items-center gap-0.5 text-xs font-medium',
            trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-500' : 'text-slate-400',
          ].join(' ')}>
            {trend > 0
              ? <TrendingUp size={12} />
              : trend < 0
              ? <TrendingDown size={12} />
              : null}
            {trend > 0 ? '+' : ''}{trend !== 0 ? `${trend.toFixed(1)}%` : 'No change'}
          </span>
        )}
      </div>
    </div>
  )
}
